import React, { useEffect, useState } from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import Leads from "../../../asset/images/onboarded.svg";
import Pending from "../../../asset/images/pending.svg";
import Created from "../../../asset/images/completed.svg";
import Rejected from "../../../asset/images/rejected.svg";
import { useNavigate } from "react-router-dom";
import { decryptData, truncate } from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";
import SmallLoader from "../../Common/smallLoader";
import { partner_Api } from "../../../Configuration/Partner_URL";
import { Modal } from "react-bootstrap";

function PartnerSideNewClientStatus(props) {
  const partnerId = localStorage.getItem("partnerId");
  // const partnerIdVal = props.partnerId;
  const partnerFlag = localStorage.getItem("partnerFlag");
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");
  const storeToken = localStorage.getItem("ssoToken");
  const [filterBy, setFilterBy] = useState("Monthly");
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [customDate, setCustomDate] = useState(false);
  const [clientStatus, setClientStatus] = useState("");

  const getClientStatus = async (daywise) => {
    setLoader(true);
    try {
      const getStatus = await axios.get(
        `${partner_Api.GET_ONBOARDING_DATA}?pCode=${partnerId}&range=${daywise}&to=${toDate}&from=${fromDate}`,
        
        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerFlag == "true" ? partnerSsoToken : storeToken}`
          },
        }
      );
      const res = decryptData(getStatus?.data);
      let decryptRespData = JSON.parse(res);

      setClientStatus(decryptRespData?.data?.info);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  

  useEffect(() => {
    if(partnerId && filterBy === "Custom"){
      if(fromDate?.length > 0 && toDate?.length > 0){
        getClientStatus(filterBy);
      }
    }else{
      getClientStatus(filterBy);
    }
    
  }, [filterBy, partnerId]);

  const handleOnChange = (e) => {
    if (e.target.value !== "Custom") {
      setFilterBy(e.target.value);
      setFromDate("");
      setToDate("");
    }
    else{
      setFilterBy(e.target.value);
      setCustomDate(true);
    }
  };
  function handleNavigate(data) {
    localStorage.setItem("activeTab", data);
    navigate("/partner-admin-onboarding");

  }

  function SubmitButton() {
    if (fromDate && toDate) {
      return (
        <button
          type="button"
          className="rej-btn "
          onClick={() => {
            getClientStatus(filterBy);
            setCustomDate(false);
          }}
        >
          Submit
        </button>
      );
    } else {
      return (
        <button type="button" className="rej-btn" disabled>
          Submit
        </button>
      );
    }
  }


  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  return (
    <>
      <div className="card-box bottom-25 client-onboarded-data">
        <div className="card-title">
          <h2>{Constants.ClientOnboardingData}</h2>

          <div className="dropdown-filter">
            <div className="card-tabs mt-0">
              <div className="dropdown-filter">
                <Form.Select
                  size="lg"
                  aria-label="Default select example"
                  onChange={handleOnChange}
                >
                  <option value="Yesterday">Yesterday</option>
                  <option value="Weekly">{Constants.Weekly}</option>
                  <option value="Monthly" selected>{Constants.Monthly}</option>
                  <option value="Yearly">{Constants.Yearly}</option>
                  <option value="Quarterly">{Constants.Quarterly}</option>
                  <option value="Till Now">Till Now</option>
                  <option value="Custom">Custom</option>
                  {/* <option value="this-month">This Month</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="this-week">This Week</option>
                  <option value="last-week">Last Week</option>
                  <option value="last-month">Last Month</option>
                  <option value="till-date">Till Date</option>
                <option value="custom-range">Custom Range</option> */}

                </Form.Select>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 ">
            <div
              className="data-card partner-datacard"
              onClick={() => handleNavigate("Leads")}
            >
              <img src={Leads} alt="Leads" />
              <div className="data-tooltip-wrapper">
                <div className="tooltip123">
                  {truncate(<span className="icon-info-icon"></span>)}
                  <span className="tooltiptext new">
                  Number of applications with mobile & email verified
                  </span>
                </div>
                {/* <div> */}
                <p className="data-card-value">
                  {loader ? (
                    <SmallLoader />
                  ) : (
                    <>
                      {clientStatus?.leads == undefined || null
                        ? "0"
                        : clientStatus?.leads}
                    </>
                  )}
                </p>
                <p className="data-card-label">{Constants.Submitted}</p>
                {/* </div> */}
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div
              className="data-card partner-datacard"
              onClick={() => handleNavigate("pending")}
            >
              <img src={Pending} alt="Pending" />
              <div className="data-tooltip-wrapper">
                <div className="tooltip123">
                  {truncate(<span className="icon-info-icon"></span>)}
                  <span className="tooltiptext new">
                    Number of Applications not submitted for client code
                    generation.
                  </span>
                </div>
                <div>
                  <p className="data-card-value">
                    {loader ? (
                      <SmallLoader />
                    ) : (
                      <>
                        {clientStatus?.incomplete == undefined || null
                          ? "0"
                          : clientStatus?.incomplete}
                      </>
                    )}
                  </p>
                  <p className="data-card-label">Application Incomplete</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div
              className="data-card partner-datacard"
              onClick={() => handleNavigate("opened")}
            >
              <img src={Created} alt="Created" />
              <div className="data-tooltip-wrapper">
                <div>
                  <p className="data-card-value">
                    {loader ? (
                      <SmallLoader />
                    ) : (
                      <>
                        {clientStatus?.accountsOpen == undefined || null
                          ? "0"
                          : clientStatus?.accountsOpen}
                      </>
                    )}
                  </p>
                  <p className="data-card-label">Account Opened</p>
                </div>
              </div>
              <div className="tooltip123">
                {truncate(<span className="icon-info-icon"></span>)}
                <span className="tooltiptext new">
                  Number of Applications submitted and Client code activated.
                </span>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div
              className="data-card partner-datacard"
              onClick={() => handleNavigate("rejected")}
            >
              <img src={Rejected} alt="Rejected" />
              <div className="data-tooltip-wrapper">
                <div className="tooltip123">
                  {truncate(<span className="icon-info-icon"></span>)}
                  <span className="tooltiptext new">
                    Number of Applications in Rejected status.
                  </span>
                </div>
                <div>
                  <p className="data-card-value">
                    {loader ? (
                      <SmallLoader />
                    ) : (
                      <>
                        {clientStatus?.accountsRejected == undefined || null
                          ? "0"
                          : clientStatus?.accountsRejected}
                      </>
                    )}
                  </p>
                  <p className="data-card-label">{Constants.Rejected}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {customDate && customDate ? (
          <Modal
            show={customDate}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="setting-model partner-modal-rejection"
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title id="contained-modal-title-vcenter">
                <h2 className="model-title">Custom Date</h2>
              </Modal.Title>
              <button type="button" className="btn-close" aria-label="Close">
                <span
                  className="icon-close"
                  onClick={() => setCustomDate(false)}
                ></span>
              </button>
            </Modal.Header>
            <Modal.Body>
              <div className="custom-modal-wrapper row">
                <div className="col-md-6  col-sm-12">
                  <label className="form-label">{Constants.From_Date}</label>
                  <input
                    type="date"
                    placeholder="DD/MM/YYYY"
                    className="form-input"
                    onChange={(e) => setFromDate(e?.target?.value)}
                    max={DateReverse}
                  />
                </div>
                <div className="col-md-6  col-sm-12">
                  <label className="form-label">{Constants.To_Date}</label>
                  <input
                    type="date"
                    placeholder="DD/MM/YYYY"
                    className="form-input"
                    onChange={(e) => setToDate(e?.target?.value)}
                    max={DateReverse}
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <SubmitButton />
            </Modal.Footer>
          </Modal>
        ) : null}
    </>
  );
}

export default PartnerSideNewClientStatus;
